// src/App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Landing from './components/Landing';
import Hero from './components/Hero';
import Team from './components/Team';
import Customers from './components/Customers';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Landing />
              <Hero />
              <Team />
              <Customers />
              <Services />
              <Contact />
            </>
          }
        />
        {/* Other routes can go here */}
      </Routes>
      <Footer />
    </>
  );
}

export default App;